const FrontPage = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='FrontPage--Riddle__Screen__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil.png' className='FrontPage--Riddle__Screen__Background__Image' />
                )} */}
                <img src='/img/page/backgrounds/background.png' className='FrontPage--Riddle__Screen__Background__Image' />
            </div>

            <div className="FrontPage--Riddle__Screen__Container">
                <img src='/img/page/adsl-five.png' className='FrontPage--Riddle__Screen__Container__Logo' style={{ maxWidth: '500px' }} />

                <p className="FrontPage--Riddle__Screen__Container__Title">ADIVINA ADIVINADOR</p>
                {/* <img src="/img/games/riddle/female/january-24-2026/provi-logotipo.png" className="FrontPage--Riddle__Screen__Container__BrandLogo" /> */}
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Five Digital Minds | 2026</footer>
        </>
    )
}

export { FrontPage };